import { render, staticRenderFns } from "./ElementStudioManagePropertyPaths.vue?vue&type=template&id=419b9cf0&"
import script from "./ElementStudioManagePropertyPaths.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioManagePropertyPaths.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports